import Orderstable from '../components/Orderstable';
import AppointmentsTable from '../components/AppointmentsTable';

// Import necessary handlers or define them here/pass them down

function FullListPage({ listType }) {
  const renderTable = () => {
    switch (listType) {
      case 'orders':
        return <Orderstable isFullPage={true} />; // Pass handlers
      case 'appointments':
        return <AppointmentsTable isFullPage={true} />; // Pass handlers
      default:
        return <p>Invalid list type.</p>;
    }
  };

  return (
      <>
        <div className="container mx-auto p-0">
        {/* Add pagination controls here if not built into the tables */}
        {renderTable()}
        </div>
    </>
  );
}

export default FullListPage;
